// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-agree .help-block[data-v-01218d34]{\n  text-align: center;\n}\n.form-button button:disabled.button-style-7[data-v-01218d34]{\n  background: #b9b9b9;\n}\n", ""]);
// Exports
module.exports = exports;
